/* - Shared By Ret Flex Index and  Subvention Index - */
export default {
  computed: {
    tableColumns () {
      return this.columns.filter(el => el.visible)
    },
    isImpersonating () {
      return this.$store.getters['LoginStore/isImpersonating']
    },
    officeConfig () {
      return (
        this.$store.getters['CompanyStore/currentCompany'].configs || false
      )
    },

    budgetClosureDates () {
      const closureDateInfo = this.officeConfig.find(
        el => el.code === 'FLEXIBLE_REMUNERATION_CLOSURE_MONTHS_DATE'
      )
      return closureDateInfo || false
    },
    currentMonth () {
      if (
        this.budgetClosureDates &&
        this.budgetClosureDates.config &&
        this.budgetClosureDates.config.currentMonth
      ) {
        const currentMonth = this.$moment.utc(
          this.budgetClosureDates.config.currentMonth.flex_rem_closure_date
        ).toDate()
        return this.$i18n.d(currentMonth, 'month_only')
      }
      return this.$i18n.t('benefits_table_header_current_month_fallback')
    }
  },
  methods: {
    generateColumnLabel (key) {
      if (key.includes('restaurants_current_assigned')) {
        return this.$i18n.t('benefits_users_table_header_meals_current_month', {
          currentMonth: this.currentMonth
        })
      }
      if (key.includes('transport_current_assigned')) {
        return this.$i18n.t(
          'benefits_users_table_header_transport_current_month',
          { currentMonth: this.currentMonth }
        )
      }
    },

    async fetchUsers (event) {
      let defaultFilters = {
        'status.statusType.code': ['ACTIVE'],
        roles: ['ROLE_REGULAR', 'ROLE_ADMIN']
      }
      let searchFilters = {}
      if (event) {
        if (event.length < 3) return // Prevent multiple search calls s
        searchFilters.query = event
      }
      const filters = { ...defaultFilters, ...searchFilters }
      await this.$store.dispatch('UsersStore/setUsersFilters', { filters: filters })
    }
  }
}
